export const adaptGroupPayload = (
	values: GroupFormValues
): Record<string, unknown> => {
	return {
		name: values.name,
		description: values.description
	};
};
